<template>
  <div class='list-group-item'>
    <div class='infopanel-subhead pb-2'>
        <!-- Last Updated: <strong>{{interests.LastUpdated | formatDate('MM/DD/YYYY')}}</strong> -->
    </div>
    <span v-if='interests' class='pandoconnect-pill' style='margin-right: 5px;' v-for='(value,key,index) in interests.Interests' :key='index'>
      {{value | capitalize}}
    </span>
    <div v-if='!interests.Interests'>
      There is currently no Interests data available.
    </div>


  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    name: 'customerInterests',
    props: [
      'interests'
    ],
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      formatDate: function (value, momentFormat) {
        if (!value) return ''
        return moment(String(value)).format(momentFormat)
      }
    }
  }

</script>

<style style='scss' scoped>
</style>



// WEBPACK FOOTER //
// src/components/CustomerProfile/CustomerInfo/InfoPanels/CustomerInterests.vue